/* eslint-disable */
import {
    Grid,
    Button,
    TextField,
    Typography,
    Paper,
    AppBar,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Toolbar,
    Tooltip, Chip,
} from "@material-ui/core";
import { withTranslation } from "react-i18next";

import GroupAddIcon from "@material-ui/icons/GroupAdd";
import { Card, CardHeader, Table, Row, Col } from "reactstrap";
import { SearchIcon } from "@chakra-ui/icons";
import RefreshIcon from "@material-ui/icons/Refresh";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { Pagination } from "@material-ui/lab";
import {
  getAllTeams,
  paginateTeams,
  getTeam,
  getTeamsFiltered,
} from "../../utils/store/actions/teams.actions";

import { show } from "redux-modal";
import ModalTeam from "../../components/Modal/Modal.team";
import React from "react";
// core components
import { connect } from "react-redux";
const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "white",
      maxWidth: "90%",
      margin: "auto",
      marginTop: "5%",
      overflow: "hidden",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
  });

class TeamsList extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      totalItems: 0,
      totalPages: 0,
      cureentPage: 1,
      load: false,
      searchFilter: "",
    };
  }

  componentDidMount() {
    this.props.getAllTeams();
  }

  editTeam = (team: any) => {
    window.location.href = `/admin/team/?id=${team.id}`;
  };
  handleChange = (e: any, value: any) => {
    this.setState({ load: !this.state.load });
    this.props.paginateTeams(value, this.state.searchFilter);
  };
  handleChangeDefault = (e: any) => {
    this.props.getTeamsFiltered(`name=${e.target.value}`);
    this.setState({ searchFilter: `name=${e.target.value}` });
    const userInput = e.currentTarget.value;

    this.setState({
      activeSuggestion: 0,
      showSuggestions: true,
      userInput: e.currentTarget.value,
    });
  };
  render() {
    const { classes, t } = this.props;
    const { teams } = this.props.Teams;
    const disabledButtonCreate =
      this.props.Users &&
      this.props.Users.get_properties &&
      (this.props.Users.get_properties.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
        ? false
        : !(
            this.props.LocalUser &&
            this.props.LocalUser.role &&
            this.props.LocalUser.role.teamCanCreate
          ));
    const disabledButtonEdit =
      this.props.Users &&
      this.props.Users.get_properties &&
      (this.props.Users.get_properties.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
        ? false
        : !(
            this.props.LocalUser &&
            this.props.LocalUser.role &&
            this.props.LocalUser.role.teamCanEdit
          ));

    return (
      <>
        <ModalTeam />
        {/* Page content */}
        <Row className={classes.rowDashboard}>
          <Col>
            <Card
              style={{
                backgroundColor: "transparent",
                borderBottom: "transparent",
              }}
            >
              <CardHeader
                style={{
                  backgroundColor: "transparent",
                  borderBottom: "transparent",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  paddingRight: "80px",
                }}
              >
                <Row>
                  <Button
                    variant="contained"
                    style={{
                      boxSizing: "border-box",
                      borderRadius: "10px",
                      color: "#ae0064",
                      backgroundColor: "white",
                      width: "200px",
                      height: "50px",
                      textTransform: "none",
                    }}
                    disabled={disabledButtonCreate}
                    className={classes.addUser}
                    onClick={() =>
                      this.props.show("team", {
                        name: "team",
                        history,
                      })
                    }
                  >
                    <GroupAddIcon style={{ marginRight: "20px" }} />
                    {t("ADD_TEAM")}
                  </Button>
                </Row>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <Paper className={classes.paper}>
          <AppBar
            className={classes.searchBar}
            position="static"
            color="default"
            elevation={0}
          >
            <Toolbar>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <SearchIcon className={classes.block} color="inherit" />
                </Grid>
                <Grid item xs>
                  <TextField
                    fullWidth
                    onChange={(e) => this.handleChangeDefault(e)}
                    placeholder={t("SEARCH_BY_NAME")}
                    InputProps={{
                      disableUnderline: true,
                      className: classes.searchInput,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Tooltip title="Reload">
                    <IconButton onClick={this.props.getAllTeams}>
                      <RefreshIcon className={classes.block} color="inherit" />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
          <div className={classes.contentWrapper}>
            {teams.content && teams.content.length !== 0 ? (
              <>
                <List>
                  {teams.content !== [] &&
                    teams.content.map((team: any) => {
                      return (
                        <div key={team.id}>
                          <ListItem>
                            <ListItemAvatar>
                              <AccountBoxIcon style={{ color: "ae0064" }} />
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <div className={classes.truncate}>
                                  <strong>
                                    {team ? team.name : "Anonymous"}
                                  </strong>{" "}
                                  {team.firstName}
                                </div>
                              }
                              secondary={
                                team.internal ? t("INTERNAL") : t("EXTERNAL")
                              }
                            />
                              {team.distributionCountry ? (
                              <ListItemText style={{
                                  color: "#2d2c2c",
                                  textAlign: 'right',

                              }}
                                  primary={
                                      <div className={classes.truncate}>
                                          <Chip
                                              style={{ maxWidth: "200px" }}
                                              key={team.distributionCountry}
                                              label={
                                                team.distributionCountry
                                                ? this.props.t("ENUMS.COUNTRIES." + team.distributionCountry)
                                                : ""
                                              }
                                              className={classes.chip}
                                          />
                                      </div>
                              }
                              />
                              ): ''}
                            <Button
                              disabled={disabledButtonEdit}
                              onClick={() => this.editTeam(team)}
                              style={{
                                color: "#ae0064",
                                textTransform: "none",
                              }}
                            >
                              {t("EDIT")}
                            </Button>
                          </ListItem>
                          <Divider />
                        </div>
                      );
                    })}
                </List>
                <Pagination
                  count={teams.totalPages}
                  page={teams.number + 1}
                  onChange={this.handleChange}
                />
              </>
            ) : (
              <>
                <Typography color="textSecondary" align="center">
                  {t("TEAMS")}
                </Typography>
              </>
            )}
          </div>
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state: {
  Teams: TeamsState;
  LocalUser: LocalUserState;
}) => ({
  Teams: state.Teams,
  LocalUser: state.LocalUser,
});

const mapDispatchToProps = {
  getAllTeams,
  paginateTeams,
  getTeam,
  getTeamsFiltered,
  show,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(TeamsList)));
